import { Loader } from '@ui-kit/components/loader';
import RangePicker, { RangeValue } from '@ui-kit/components/rangePicker';
import React, { useEffect, useState } from 'react';
import { useAsyncData } from '@utils/hooks';
import DataTable, { ColumnType } from '@base/ui/components/dataTable';
import styles from '../styles/filteredDataTable.module.scss';
import { t } from '@base/utils/helpers';

export default function FilteredDataTable<T, U>(props: {
  getData: (range?: RangeValue) => Promise<T>;
  getTableData: (data: T) => U[];
  columns: ColumnType<U>[];
  rangePickerTitle?: string;
  empty?: JSX.Element;
  tableStyle?: React.CSSProperties;
  footer?: (data: T) => JSX.Element;
}) {
  const { data, loading, setData } = useAsyncData(() => props.getData());
  const [range, setRange] = useState<RangeValue | undefined>(undefined);

  useEffect(() => {
    if (!range) return;
    (async () => {
      try {
        const res = await props.getData(range);
        setData(res);
      } catch (e) {
        console.error(e);
      }
    })();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [range]);

  return (
    <div className={styles.filteredTable}>
      <div className={styles.rangePicker}>
        <h3>{props.rangePickerTitle}</h3>
        <RangePicker value={range} onChange={setRange} placeholder={[t('from'), t('to')]} />
      </div>
      <DataTable
        data={data ? props.getTableData(data) : []}
        columns={props.columns}
        empty={props.empty}
        style={props.tableStyle}
        loading={loading}
      />
      <footer>{data && props.footer?.(data)}</footer>
    </div>
  );
}
